import React, { useState } from 'react';
import { deviceAPI } from '../services/api';
import './DeviceRegistration.css';

function DeviceRegistration({ onDeviceRegistered }) {
  const [formData, setFormData] = useState({
    deviceId: '',
    deviceName: '',
    description: '',
    ipAddress: '',
    location: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await deviceAPI.register(formData);
      setMessage({ type: 'success', text: response.data.message });
      setFormData({
        deviceId: '',
        deviceName: '',
        description: '',
        ipAddress: '',
        location: ''
      });
      if (onDeviceRegistered) {
        onDeviceRegistered(response.data.data);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to register device'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registration-form">
      <h2>Register New Device</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="deviceId">Device ID *</label>
          <input
            type="text"
            id="deviceId"
            name="deviceId"
            value={formData.deviceId}
            onChange={handleChange}
            required
            placeholder="e.g., DEV001"
          />
        </div>

        <div className="form-group">
          <label htmlFor="deviceName">Device Name *</label>
          <input
            type="text"
            id="deviceName"
            name="deviceName"
            value={formData.deviceName}
            onChange={handleChange}
            required
            placeholder="e.g., Main Gateway"
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Optional description"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label htmlFor="ipAddress">IP Address</label>
          <input
            type="text"
            id="ipAddress"
            name="ipAddress"
            value={formData.ipAddress}
            onChange={handleChange}
            placeholder="e.g., 192.168.1.100"
          />
        </div>

        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="e.g., Building A, Floor 2"
          />
        </div>

        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? 'Registering...' : 'Register Device'}
        </button>
      </form>
    </div>
  );
}

export default DeviceRegistration;
